import { Card, Typography, Divider } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import VendorInformation from "../../../Components/VendorInformation";
import { jwtDecode } from "jwt-decode";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";
import { useEffect } from "react";

const AddVendor = () => {
  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(
      storageKeys?.USER_TOKEN,
      {},
      "get"
    );
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Manage Vendor", permissionJson, "edit")) {
        navigate("/manage-vendor");
      }
    } else {
      if (!checkPermissionAction("Manage Vendor", permissionJson, "add")) {
        navigate("/manage-vendor");
      }
    }
  }, []);

  return (
    <>
      <Card>
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined
              className="mr-2"
              onClick={() => navigate("/manage-vendor")}
            />
            {id ? "Edit" : "Add"} Vendor
          </Typography>
        </div>
        <Divider />
        <VendorInformation />
      </Card>
    </>
  );
};
export default AddVendor;
